// Payment gateway selection, QR code generation, and screenshot upload.
// Activated only on /payment/pay pages.
(function () {
    'use strict';

    if (window.location.pathname !== '/payment/pay') return;

    var paymentPage = document.querySelector('.payment-page');
    if (!paymentPage) return;

    var feeName = paymentPage.dataset.fee;
    var amount  = paymentPage.dataset.amount;

    if (!feeName) return;

    // --- QR Code Generation ---
    var upiID = 'snapvtd@upi';
    var numericAmount = parseFloat(amount.replace(/,/g, ''));
    if (!isNaN(numericAmount) && numericAmount > 0) {
        var upiUri = 'upi://pay?pa=' + encodeURIComponent(upiID)
            + '&am=' + numericAmount.toFixed(2)
            + '&cu=INR';

        try {
            if (typeof qrcode === 'function') {
                var qr = qrcode(0, 'H');
                qr.addData(upiUri);
                qr.make();
                var qrContainer = document.getElementById('qrcode');
                if (qrContainer) {
                    qrContainer.innerHTML = qr.createSvgTag({
                        cellSize: 10,
                        margin: 4,
                        scalable: true
                    });
                }
            }
        } catch (e) {
            console.error('QR code generation failed:', e);
        }
    }

    // --- Gateway Selection ---
    var gatewayInputs = document.querySelectorAll('.payment-list__radio[name="payment_gateway"]');
    var qrSection     = document.getElementById('payment-qr-section');
    var processing    = document.getElementById('payment-processing');
    var errorBox      = document.getElementById('payment-error');
    var errorMsg      = document.getElementById('payment-error-msg');
    var retryBtn      = document.getElementById('payment-retry-btn');
    var gatewayContainers = document.querySelectorAll('.payment-container');

    function showProcessing() {
        if (processing) processing.classList.remove('d-none');
    }
    function hideProcessing() {
        if (processing) processing.classList.add('d-none');
    }
    function showError(msg) {
        if (errorBox) errorBox.classList.remove('d-none');
        if (errorMsg) errorMsg.textContent = msg;
    }
    function hideError() {
        if (errorBox) errorBox.classList.add('d-none');
    }

    if (retryBtn) {
        retryBtn.addEventListener('click', function () {
            hideError();
            // Re-enable radios
            gatewayInputs.forEach(function (inp) {
                inp.disabled = false;
                inp.checked = false;
            });
        });
    }

    gatewayInputs.forEach(function (input) {
        input.addEventListener('change', function () {
            var gateway = this.value;

            hideError();

            // QR code option
            if (gateway === 'qr-scan') {
                if (qrSection) qrSection.classList.remove('d-none');
                // Hide the gateway containers but keep them in DOM
                gatewayContainers.forEach(function (c) { c.classList.add('d-none'); });
                return;
            }

            // Hide QR if was visible
            if (qrSection) qrSection.classList.add('d-none');

            // Disable all radios while processing
            gatewayInputs.forEach(function (inp) { inp.disabled = true; });
            showProcessing();

            var paymentGateway = gateway.toLowerCase();

            fetch('/api/payment/generate?fee=' + encodeURIComponent(feeName) + '&gateway=' + encodeURIComponent(paymentGateway), {
                method: 'POST',
                credentials: 'same-origin'
            })
            .then(function (resp) {
                return resp.json().then(function (body) {
                    return { ok: resp.ok, body: body };
                });
            })
            .then(function (result) {
                hideProcessing();

                if (!result.ok || !result.body || result.body.status === 0) {
                    var msg = (result.body && result.body.error)
                        ? result.body.error
                        : 'Error processing payment. Please try again.';
                    showError(msg);
                    gatewayInputs.forEach(function (inp) { inp.disabled = false; });
                    return;
                }

                var paymentUrl = result.body.data && result.body.data.payment_url;
                if (!paymentUrl) {
                    showError('No payment URL received. Please try again.');
                    gatewayInputs.forEach(function (inp) { inp.disabled = false; });
                    return;
                }

                // Route to the correct gateway
                if (paymentGateway === 'phonepe' || paymentGateway === 'instamojo') {
                    window.location.href = paymentUrl;
                    return;
                }

                if (paymentGateway === 'cashfree') {
                    try {
                        var cashfreeInstance = Cashfree({ mode: paymentPage.dataset.cfMode || 'production' });
                        cashfreeInstance.checkout({
                            paymentSessionId: paymentUrl,
                            redirectTarget: '_self'
                        });
                    } catch (cfErr) {
                        console.error('Cashfree checkout error:', cfErr);
                        showError('Cashfree checkout failed. Please try another gateway.');
                        gatewayInputs.forEach(function (inp) { inp.disabled = false; });
                    }
                    return;
                }

                // Fallback for unknown gateways — try direct redirect
                window.location.href = paymentUrl;
            })
            .catch(function (err) {
                hideProcessing();
                console.error('Payment generate request failed:', err);
                showError('Network error. Please check your connection and try again.');
                gatewayInputs.forEach(function (inp) { inp.disabled = false; });
            });
        });
    });

    // --- Screenshot Upload (QR Code flow) ---
    var dropZone         = document.getElementById('dropZone');
    var fileInput        = document.getElementById('fileInput');
    var browseBtn        = document.getElementById('browseBtn');
    var previewContainer = document.getElementById('previewContainer');
    var dropZoneContent  = document.getElementById('dropZoneContent');
    var thumbnailGrid    = document.getElementById('thumbnailGrid');
    var fileList         = document.getElementById('fileList');
    var reuploadBtn      = document.getElementById('reuploadBtn');
    var submitSsBtn      = document.getElementById('submit-ss-btn');

    if (browseBtn && fileInput) {
        browseBtn.addEventListener('click', function () { fileInput.click(); });
    }
    if (reuploadBtn && fileInput) {
        reuploadBtn.addEventListener('click', function () { fileInput.click(); });
    }

    if (fileInput) {
        fileInput.addEventListener('change', function () {
            handleFiles(this.files);
        });
    }

    if (dropZone) {
        dropZone.addEventListener('dragover', function (e) {
            e.preventDefault();
            dropZone.classList.add('dragover');
        });
        dropZone.addEventListener('dragleave', function () {
            dropZone.classList.remove('dragover');
        });
        dropZone.addEventListener('drop', function (e) {
            e.preventDefault();
            dropZone.classList.remove('dragover');
            handleFiles(e.dataTransfer.files);
        });
    }

    function handleFiles(files) {
        if (!files || files.length === 0) return;

        if (thumbnailGrid) thumbnailGrid.innerHTML = '';
        if (fileList) fileList.innerHTML = '';

        var file = files[0];
        if (!file.type.startsWith('image/')) {
            showError('Please select an image file (JPEG, PNG, etc.).');
            return;
        }

        // Max 10MB
        if (file.size > 10 * 1024 * 1024) {
            showError('File size exceeds 10MB limit.');
            return;
        }

        // Show preview
        if (dropZoneContent) dropZoneContent.classList.add('d-none');
        if (previewContainer) previewContainer.classList.remove('d-none');

        var reader = new FileReader();
        reader.onload = function (e) {
            if (thumbnailGrid) {
                thumbnailGrid.innerHTML = '<img src="' + e.target.result + '" alt="Preview" style="max-width:200px;max-height:200px;border-radius:8px;">';
            }
        };
        reader.readAsDataURL(file);

        if (fileList) {
            fileList.innerHTML = '<span>' + escapeHtml(file.name) + '</span>'
                + ' <span style="color:#888;">(' + formatFileSize(file.size) + ')</span>';
        }
    }

    if (submitSsBtn) {
        submitSsBtn.addEventListener('click', function () {
            if (!fileInput || !fileInput.files || !fileInput.files[0]) {
                showError('Please select a screenshot to upload.');
                return;
            }

            var file = fileInput.files[0];
            var data = new FormData();
            data.append('file_attachment', file);
            data.append('fee', feeName);

            submitSsBtn.disabled = true;
            submitSsBtn.textContent = 'Uploading…';

            fetch('/api/payment/upload', {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            })
            .then(function (resp) { return resp.json(); })
            .then(function (result) {
                if (result && result.status === 1) {
                    showPaymentNotification('Screenshot uploaded successfully!', 'success');
                    // Reset the upload area
                    if (dropZoneContent) dropZoneContent.classList.remove('d-none');
                    if (previewContainer) previewContainer.classList.add('d-none');
                    if (fileInput) fileInput.value = '';
                } else {
                    showError((result && result.error) || 'Upload failed. Please try again.');
                }
            })
            .catch(function () {
                showError('Network error during upload. Please try again.');
            })
            .finally(function () {
                submitSsBtn.disabled = false;
                submitSsBtn.textContent = 'Submit Screenshot';
            });
        });
    }

    function formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function showPaymentNotification(message, type) {
        var existing = document.getElementById('payment-notification');
        if (existing) existing.remove();

        var div = document.createElement('div');
        div.id = 'payment-notification';
        div.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);'
            + 'z-index:100000;padding:14px 28px;border-radius:8px;font-size:15px;'
            + 'font-weight:500;color:#fff;box-shadow:0 4px 20px rgba(0,0,0,0.3);'
            + 'transition:opacity 0.4s ease;max-width:90vw;text-align:center;';
        div.style.background = type === 'error' ? '#d9534f' : '#28a745';
        div.textContent = message;
        document.body.appendChild(div);

        setTimeout(function () {
            div.style.opacity = '0';
            setTimeout(function () { div.remove(); }, 500);
        }, 5000);
    }
})();
